/* eslint-disable @stylistic/max-statements-per-line */
/* eslint-disable @stylistic/indent */
import { errorJSONStringify } from '@/utils/utils'

const HISTORY_STORAGE_KEY = '__WNI_CLOTHES_HISTORY__'
const HISTORY_KEY = 'historyKey'
const HISTORY_MAX = 3

export const readHistory = function (_key) {
    try {
        const currentHistory = readLocalStorage(_key)
        return currentHistory
    } catch (e) {
        console.log(errorJSONStringify(e))
        return []
    }
}

export const addHistory = function (addHistory, _key) {
    try {
        const currentHistory = readLocalStorage(_key)

        // 新しい履歴を追加
        const historyKey = addHistory?.[HISTORY_KEY]
        if (!historyKey) { return currentHistory }

        // 最終的に保存する履歴
        const newHistory = []

        // 現状の履歴を保存
        newHistory.push(addHistory)

        // 現状の履歴から最大までの履歴を追加
        for (const item of currentHistory) {
            const historyKey = item?.[HISTORY_KEY]
            if (historyKey && !newHistory.some((item) => item?.[HISTORY_KEY] === historyKey)) {
                newHistory.push(item)
            }
            if (newHistory.length >= HISTORY_MAX) {
                break
            }
        }
        saveLocalStorage(newHistory, _key)
        return newHistory
    } catch (e) {
        console.log(errorJSONStringify(e))
        return false
    }
}

export const saveLocalStorage = function (object, _key) {
    try {
        const key = (_key) ? _key : HISTORY_STORAGE_KEY
        localStorage.setItem(key, JSON.stringify(object))
        return true
    } catch (e) {
        console.log(errorJSONStringify(e))
        return false
    }
}

// ローカルストレージから読み出す関数
export const readLocalStorage = function (_key) {
    try {
        const key = (_key) ? _key : HISTORY_STORAGE_KEY
        const data = localStorage.getItem(key)
        return data ? JSON.parse(data) : []
    } catch (e) {
        console.log(errorJSONStringify(e))
        return []
    }
}
